import { SellerFilterOption } from '@/components/SellerFilter/SellerFilterUi';
import cacheKeys from '@/data/api/cacheKeys';
import { searchProducts } from '@/data/api/request/draftOrderRequests';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

export default function useSearchProducts() {
  const [query, setQuery] = useState<string>('');
  const [sellerFilters, setSellerFilters] = useState<SellerFilterOption[]>();

  const { data, isFetching, error } = useQuery({
    queryKey: [cacheKeys.product.search, { query }, sellerFilters],
    queryFn: () =>
      searchProducts(
        query,
        sellerFilters?.map((item) => item.sellerId)
      ),
    enabled: !!query.trim(),
  });

  return {
    data,
    isFetching,
    error,
    setQuery,
    setSellerFilters,
  };
}
